module.exports = __webpack_public_path__ + "assets/media/day5.9bb606fd.mp3";